// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1775":"css/admin-app.6914","6296":"css/app.6914"}[chunkId] + ".css";
};